export default timestamp => {
	const date = new Date(timestamp)
	const dateString = date.toLocaleDateString('ru-RU')
	const timeString = date.toLocaleTimeString('ru-RU')

	return `${dateString} ${timeString}`
}
